module.exports = __webpack_public_path__ + "static/media/woodgrain-lines.df496065.svg";